// import { HttpInterceptorFn } from '@angular/common/http';

// export const adminTokenInterceptor: HttpInterceptorFn = (req, next) => {
//     // Match admin controllers by prefix (case-insensitive)
//     const u = req.url.toLowerCase();
//     const isAdminApi =
//         u.includes('/adminauth/') ||
//         u.includes('/adminprofile/') ||
//         u.includes('/admin/') ||           // keep if you add /Admin/... later
//         u.includes('/admindocuments/') ||
//         u.includes('/admin');              // fallback for absolute urls

//     if (!isAdminApi) return next(req);

//     const token = localStorage.getItem('admin_token');
//     if (!token) return next(req);

//     return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
// };

import { HttpInterceptorFn } from '@angular/common/http';

export const adminTokenInterceptor: HttpInterceptorFn = (req, next) => {
    const u = req.url.toLowerCase();

    // attach only for admin endpoints
    const isAdminApi =
        u.includes('/adminauth/') ||
        u.includes('/adminprofile/') ||
        u.includes('/admindocuments/') ||
        /\/admin(\/|$)/i.test(req.url);

    if (!isAdminApi) return next(req);

    const token =
        localStorage.getItem('admin_token') ??
        sessionStorage.getItem('admin_token');

    if (!token) return next(req);

    return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};